import { dev, nodeEnvironment } from '../utils/environment-utils'
import { env } from '../env'
import { isServer } from '../utils/platform-utils'

interface AppConfig {
    basePath: string
    baseUrl: string
    dev: boolean
    environment: 'development' | 'staging' | 'production'
    firebaseApiKey?: string
    firebaseAppId?: string
    firebaseMessagingSenderId?: string
    firebaseProjectId: string
    firebaseAuthDomain: string
    firebaseStorageBucket: string
    gtmContainerId: string
    nodeEnvironment: 'development' | 'production'
    sentryDSN: string
    googleSiteVerification: string
    assetPrefix: string
    gMapKey: string
    googleEmbeddedMapsKey: string
    htgPublicUrl: string
    gygPartnerId?: string
    mediaBaseUrl: string
}

const config: AppConfig = {
    basePath: process.env.NEXT_PUBLIC_BASE_PATH!,
    // Server-only + runtime (per-deploy): never bake it. The client uses location.origin.
    baseUrl: isServer ? env.BASE_URL : '',
    dev,
    environment: process.env.NEXT_PUBLIC_ENV as AppConfig['environment'],
    firebaseApiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    firebaseAppId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
    firebaseMessagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    firebaseProjectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID ?? '',
    firebaseAuthDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN ?? '',
    firebaseStorageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET ?? '',
    gtmContainerId: process.env.NEXT_PUBLIC_GTM_CONTAINER_ID!,
    nodeEnvironment,
    sentryDSN: process.env.NEXT_PUBLIC_SENTRY_DSN ?? '',
    googleSiteVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION!,
    assetPrefix: process.env.NEXT_PUBLIC_ASSET_PREFIX!,
    gMapKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY!,
    googleEmbeddedMapsKey: process.env.NEXT_PUBLIC_GOOGLE_EMBEDDED_MAPS_KEY!,
    htgPublicUrl: process.env.NEXT_PUBLIC_HTG_PUBLIC_URL!,
    gygPartnerId: process.env.NEXT_PUBLIC_GYG_PARTNER_ID,
    mediaBaseUrl: process.env.NEXT_PUBLIC_MEDIA_BASE_URL!,
}

export default config
